import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  loadAllJobsByParams,
  loadJobFunctions,
} from '@modules/reports/store/referral-reports.actions';
import { JobsPageFilterType } from '@modules/jobs-page/store/filter/filter.reducer';
import { Subpages } from '@modules/reports/models/subpages';
import { JobStatusEnum } from '@shared/models/job-statuses';
import {
  loadActiveJobsCount,
  loadAggregatedMatches,
  loadTotalDirectPerPhase,
} from '@collections/aggregations';

@Injectable()
export class PipelinePageResolver {
  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    this.store.dispatch(
      loadAllJobsByParams({
        params: {
          jobAssignedTo: JobsPageFilterType.ALL,
          offset: 0,
          status: JobStatusEnum.Published,
        },
      }),
    );

    this.store.dispatch(loadActiveJobsCount({ filters: { jobStatus: JobStatusEnum.Published } }));
    this.store.dispatch(loadAggregatedMatches({ filters: { jobStatus: JobStatusEnum.Published } }));
    this.store.dispatch(
      loadTotalDirectPerPhase({ filters: { jobStatus: JobStatusEnum.Published } }),
    );
    this.store.dispatch(
      loadJobFunctions({
        filters: { jobStatus: JobStatusEnum.Published },
        functionsPage: Subpages.PIPELINE,
      }),
    );
  }
}
